module.exports = __webpack_public_path__ + "img/probe_2-min.f820d7e4.png";